import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import {Row,Col,Form} from 'react-bootstrap';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux'

import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';

import {URL_IMG} from '../../../configs/urlConfigs';
import {LBL_MUTE_EMAILS, LBL_MUTE_NOTICATIONS, LBL_SLNUM, LBL_NAME, LBL_POSITION, LBL_PHONE,LBL_EMAIL,LBL_PROFILE_NAME, LBL_FIRST_NAME, LBL_EMAIL_ADDRESS, LBL_RESEND_VERIFI_EMAIL, LBL_NOT_VERIFIED, LBL_ROLE, LBL_SEND_VERIFI_EMAIL,LBL_LAST_NAME,LBL_CONTACT_NUMBER, LBL_ADD_CONTACT, LBL_CLIENT_NAME} from '../../../configs/labelConfigs';
import {MSG_REQUIRED,MSG_FILE_SIZE_ERROR,MSG_FILE_FORMAT_ERROR, MSG_LOGO_FORMAT,MSG_CLIENT_CNCT_DETAILS_ADD,MSG_CLIENT_CNCT_DETAILS_UPDATE, MSG_DUPLICATION,MSG_CLIENT_CNCT_SEND_MAIL,MSG_MAIL_RESEND,MSG_DATA_SAVE_ERROR} from '../../../configs/msgConfigs';
import {LOGIN_CLIENT_GROUP,PHONE_ISD_CODE, PHONE_ISD_NUM} from '../../../configs/staticConfigs';
import ModalWindow from '../../commons/helpers/modalWindow';

import { clientContactAddAction} from '../../../actions/clientActions';
import { assUserEditAction, assUserUpdateAction} from '../../../actions/assUserActions'; // assUserDeleteAction
import {clearAction,profileRoleGetAction,resendEmailAction} from '../../../actions/commonActions';

import {validateEmail,imageExtension,fileSize} from '../../../utils/validation'; // formValid
import * as types from '../../../actions';
import PhoneInput from 'react-phone-input-2';
import Cropper from 'react-easy-crop'
import 'react-easy-crop/react-easy-crop.css'
import getCroppedImg from '../../commons/image-cropper/cropImage'
import Toast from '../../commons/helpers/toast';
import CustomTitle from '../../commons/helpers/customTitle';

class ClientContactAdd extends Component {

    constructor(props){
        super()

        this.state = {
            contactId:'',
            toastMessage:'',
            toastFlag:false,
            toastSuccess:true,
            formErrors:{
                firstName:"",
                lastName:"",
                contactNumber:'',
                emailAddress:'',
                role:''
            },
            contactData:{
                firstName:null,
                lastName:null,
                contactNumber:'',
                emailAddress:'',
                position:'',
                logo:'',
                sendEmail:false,
                emailVerify:false,
                role:'',
                primary_contact:false,
                muteMails:false,
                mutePushs:false
            },
            imgUrl:'',       
            logoLabel:MSG_LOGO_FORMAT,
            isLogoValid:true,
            image: '',
            crop: { x: 0, y: 0 },
            zoom: 1,
            aspect: 4 / 4,
            croppedArea:{},
            croppedAreaPixels:{},
            rotation:0,
            imgObj:null,
            modifiedImg:null,
            saveFormDataClicked:0,
            editContactClicked: 0,      
            editContactId: 0, 
            addContactClicked: 0,      
        }
        this.onHandleChange      = this.onHandleChange.bind(this);
        this.callToaster         = this.callToaster.bind(this);

        this.modalCropper = React.createRef();  

    }

    onCropChange = crop => {
        this.setState({ crop })
    }
 
    onCropComplete = (croppedArea, croppedAreaPixels) => {
        this.setState({croppedArea:croppedArea,croppedAreaPixels:croppedAreaPixels})
    }
 
    onZoomChange = zoom => {
        this.setState({ zoom })
    }

    setCroppedImage(){ 
        this.modalCropper.current.handleModelClose();
    }
    
    cropImage(e){
        let {imgObj,croppedAreaPixels,rotation,imgUrl} = this.state
        const obj = this;
        let canvas = getCroppedImg(
            imgObj,
            croppedAreaPixels,
            obj,
            rotation,
            'clientAsso'
        )

    }
    
    onModalFormReset = () =>{       
        this.setState({
            contactId:'',
            contactData:{
                firstName:null,
                lastName:null,
                contactNumber:'',
                emailAddress:'',
                position:'',
                role:null,
                primary_contact:false,
                muteMails:false,
                mutePushs:false
            },
            imgUrl:'',   
            formErrors:{
                firstName:"",
                lastName:"",
                contactNumber:'',
                emailAddress:'',
                role:''
            }               
        }); 
    } 

    resetFormErrors=()=>{
        let formErrors = this.state.formErrors;      
        formErrors.firstName = '';
        formErrors.lastName = '';
        formErrors.contactNumber = '';
        formErrors.emailAddress = '';
        this.setState({formErrors});
    }

    onHandleChange = (e) =>{
        const {name}  = e.target;
        let value     = '';
        
        switch(e.target.type){
            case 'file':
                value = e.target.files[0];
                break;
            case 'checkbox':
                value = e.target.checked;
                break;            
            default:
                value = e.target.value;
                break;
        }
        
        let formErrors      = this.state.formErrors;
        let logoValid       = true;
        let logoError       = MSG_LOGO_FORMAT; 
        let trimmedValue = '';

        if(e.target.type==="text" || e.target.type==="tel" || e.target.type==="email"){
            trimmedValue = value.trim(); 
        }
        
        let contactData   = this.state.contactData;

        switch(name){ 
            case 'logo':
                if (!fileSize(value.size)) {
                    logoError     = MSG_FILE_SIZE_ERROR;
                    logoValid = false;
                }
                if(!imageExtension(value.name)){
                    logoError     = MSG_FILE_FORMAT_ERROR;
                    logoValid = false;
                }      
                break;    
            case 'firstName': formErrors.firstName =  trimmedValue.length <=0  ? MSG_REQUIRED : ""
              formErrors.role = ""
              break;   
            case 'lastName': formErrors.lastName = trimmedValue.length <=0  ? MSG_REQUIRED : ""
              break;     
            case 'contactNumber':
              formErrors.contactNumber =  (contactData.primary_contact && trimmedValue.length <=0)  ? MSG_REQUIRED : ""
              break;        
            case 'emailAddress':
              formErrors.emailAddress =  (contactData.primary_contact && (trimmedValue.length <=0 || validateEmail(value) === false)) ? MSG_REQUIRED : ""
              break;    
                       
            default :
            break;
        }
  
        
        contactData[name] = value;

        if(e.target.type=== "file"){
            let imgUrl = '';
            let imgObj = null;
            if(imageExtension(e.target.files[0].name)){
                imgObj = e.target.files[0]
                imgUrl = URL.createObjectURL(e.target.files[0]);
            }
            this.setState({imgUrl:imgUrl,imgObj:imgObj});
            document.getElementById('uploadContactProfile').value = '';
            this.openCropModal()
        }
        
        this.setState({formErrors,contactData,isLogoValid:logoValid,logoLabel:logoError});
  
    }

    onPhoneInputChange = (value, data, event, formattedValue) =>{
        let contactData   = this.state.contactData;
        let formErrors   = this.state.formErrors;
        contactData['contactNumber'] = formattedValue.trim();
        if(contactData.primary_contact) {
            formErrors.contactNumber = value.trim()===data.dialCode ? MSG_REQUIRED : "";
            formErrors.contactNumber = formattedValue.trim().length<5 ? MSG_REQUIRED : "";
            this.setState({formErrors,contactData});
        }
        else {
            this.setState({contactData});
        }
    }

    validateForm = () => {
        let contactData   = this.state.contactData;  
        let formErrors    = this.state.formErrors;
        let foundIssues = 0; 
        if(!contactData.firstName || contactData.firstName.trim().length===0) {
            foundIssues = 1; 
            formErrors.firstName =  MSG_REQUIRED; 
        }
        if(!contactData.lastName || contactData.lastName.trim().length===0) {
            foundIssues = 1; 
            formErrors.lastName =  MSG_REQUIRED; 
        }
        if(contactData.primary_contact && (!contactData.contactNumber || contactData.contactNumber.trim().length===0)) {
            foundIssues = 1; 
            formErrors.contactNumber =  MSG_REQUIRED; 
        }
        if(contactData.primary_contact && (!contactData.emailAddress || contactData.emailAddress.trim().length===0 || validateEmail(contactData.emailAddress) === false)) {
            foundIssues = 1; 
            formErrors.emailAddress =  MSG_REQUIRED; // validateEmail
        }
        if(contactData.emailAddress && contactData.emailAddress.trim().length > 0 && validateEmail(contactData.emailAddress) === false) {
            foundIssues = 1; 
            formErrors.emailAddress =  MSG_REQUIRED; 
        }

        if(foundIssues) {
            this.setState({formErrors});
            return false;
        }
        else {
            return true; 
        }
    }

    onSaveFormData = (e) =>{
        let contactData   = this.state.contactData;   
        if(this.validateForm()) { // if(formValid(this.state))
            const data   = new FormData();
            let role = document.getElementsByName('role')[0].value; 
            data.append('client_profile', this.props.clientId);   
            data.append('first_name', contactData.firstName);            
            data.append('last_name', contactData.lastName);
            data.append('mobile', contactData.contactNumber);
            data.append('email', contactData.emailAddress);
            data.append('position', contactData.position);
            data.append('role', role); 
            data.append('send_mail', contactData.sendEmail?1:0);

            data.append('profile_picture', (contactData.logo) ? contactData.logo : '');                 
            data.append('mute_mails', contactData.muteMails);                 
            data.append('mute_pushs', contactData.mutePushs);
                          
            if(this.state.contactId){
                data.append('assUserId', this.state.contactId);
                data.append('status', 1);
                this.props.assUserUpdateAction(data);
            }else{
                this.props.clientContactAddAction(data);
            }
        }
    }

    editBtnClick = (rowId) =>{        
        this.resetFormErrors();
        this.modal.current.handleOpenModal();
        this.props.assUserEditAction(rowId);
    }
    openCropModal =() =>{
        this.modalCropper.current.handleOpenModal();
    }
  
    setStateUpdate(contactActivity,status,contactUser,roles,errorData,sendMailStatus,activity,contactUserData){
        let formErrors = this.state.formErrors;   
        if(contactActivity===types.CLIENT_CONTACT_ADD_SUCCESS){ 
            this.callToaster(true,MSG_CLIENT_CNCT_DETAILS_ADD,true);
            this.props.clearAction();
            this.props.refreshParent(contactUserData);
        }else if(contactActivity===types.CLIENT_CONTACT_ADD_ERROR){  
            
            if(status===400){
                formErrors.emailAddress = MSG_DUPLICATION;
                this.setState({formErrors}); 
            }else{
                //this.modal.current.handleModelClose();
                if(errorData.hasOwnProperty('message')){ 
                    this.callToaster(true,errorData.message,false);
                }else{
                    this.callToaster(true,JSON.stringify(errorData),false);
                }
            }
        }else if(contactActivity===types.ASS_USER_EDIT_SUCCESS){

            this.setState({
                contactData:{
                    firstName:contactUser.firstName,
                    lastName:contactUser.lastName,
                    contactNumber:contactUser.contactNumber,
                    emailAddress:contactUser.emailAddress,
                    position:contactUser.position,
                    logo:'',
                    emailVerify:contactUser.emailVerify,
                    role:contactUser.role,
                    primary_contact:contactUser.primary_contact?contactUser.primary_contact:false, 
                    muteMails:contactUser.mute_mails,
                    mutePushs:contactUser.mute_pushs
                },
                contactId:contactUser.userId,
                imgUrl:contactUser.logo,
                formErrors:{
                    firstName:'',
                    lastName:'',
                    contactNumber:'',
                    emailAddress:'',
                    role:''
                }
            });
        }else if(contactActivity===types.ASS_USER_UPDATE_SUCCESS){
            this.onModalFormReset(); 
            if(sendMailStatus==='1'){
                this.callToaster(true,MSG_CLIENT_CNCT_SEND_MAIL,true,false);
            }else{
                this.callToaster(true,MSG_CLIENT_CNCT_DETAILS_UPDATE,true);
            }
            // this.props.clientContactListAction({clientId:this.props.clientId,column:this.state.sortOrder+this.state.sortField});
            this.props.clearAction();
            this.props.refreshParent();
        }else if(contactActivity===types.ASS_USER_UPDATE_ERROR){
            if(status===400){
                formErrors.emailAddress = MSG_DUPLICATION;
                this.setState({formErrors}); 
            }else{
                // this.modal.current.handleModelClose();
                if(errorData.hasOwnProperty('message')){ 
                    this.callToaster(true,errorData.message,false);
                }else{
                    this.callToaster(true,JSON.stringify(errorData),false);
                }
            }
        }else if(contactActivity===types.PROFILE_ROLE_SUCCESS){
            // let userRole = roles.filter((role) => role.name === 'admin');
            // if(roles.length>0){
            //     this.setState({roleId:userRole[0].id});
            // }
        } else if(activity===types.RESEND_EMAIL_SUCCESS){ 
            this.callToaster(true,MSG_MAIL_RESEND,true,false);
        }else if(activity===types.RESEND_EMAIL_ERROR){
            this.callToaster(true,MSG_DATA_SAVE_ERROR,false); 
        } 
    }

    componentDidUpdate(prevProps) {
        const { status,contactActivity,contactUser,roles,errorData,sendMailStatus,saveFormDataClicked,editContactClicked, editContactId, addContactClicked,activity,contactUserData} = this.props;    
        
        

        if(saveFormDataClicked > 0 && saveFormDataClicked!==prevProps.saveFormDataClicked) {
            this.onSaveFormData(''); 
        }

        if(Number(addContactClicked) > Number(this.state.addContactClicked)) {
            this.resetFormErrors();
            this.onModalFormReset(); 
            this.setState({addContactClicked}); 
        } else if(editContactClicked!==this.state.editContactClicked && Number(editContactId) > 0) {
            this.resetFormErrors();
            this.setState({editContactClicked:editContactClicked, editContactId:editContactId}, () => {
                this.props.assUserEditAction(this.state.editContactId);
            }); 
        } else if (contactActivity !== prevProps.contactActivity) {
            this.setStateUpdate(contactActivity,status,contactUser,roles,errorData,sendMailStatus,activity,contactUserData);
            this.props.clearAction();
        }

        if(this.props.clientId && this.props.clientId!==prevProps.clientId){
            this.props.profileRoleGetAction({profileId:this.props.clientId, userType:LOGIN_CLIENT_GROUP});
        }

    }

    componentDidMount() {
        if(this.props.clientId){
            this.props.profileRoleGetAction({profileId:this.props.clientId, userType:LOGIN_CLIENT_GROUP});
        }
    }

    callToaster(isEnabled,message,isSucces,isAutoHide=true) {
        this.props.setToasterStatePop(isEnabled,message,isSucces,isAutoHide);
    }
    
    render(){

        const { formErrors, contactData,imgUrl,logoLabel,isLogoValid,contactId} = this.state; 
        const { count,roles,id,clientName } = this.props; 
        
        let logoUrl = require('../../../'+URL_IMG+'profile-image.png');
        if(imgUrl){
            logoUrl = imgUrl;
        }    
        
        return(     
            <div className="box">
                
                <div className="box-content">
                    <Form>
                        <Form.Group>
                           {id!=="quotes-contact-add" && <Row>
                                <div className="col-md-12 text-center">
                                    <div className="company-logo">
                                    <img src={logoUrl} alt={LBL_PROFILE_NAME} />  
                                    <p className={isLogoValid?'logo-txt':'text-red logo-txt'}><small>{logoLabel}</small></p>                                          
                                    <label htmlFor="uploadContactProfile"><i className="las la-pen"></i></label> 
                                    <input type="file" id="uploadContactProfile" name="logo" onChange={this.onHandleChange} accept=".png, .jpg"/>                                          
                                </div>
                                </div>
                            </Row>}
                       

                            <Row>
                            <div className="col-md-12">
                            {id==="quotes-contact-add" && <CustomTitle title={LBL_ADD_CONTACT} className="mb-2" />}
                            </div>
                            </Row>
                            {(id === "quotes-contact-add" && clientName&&clientName.length>0) &&   
                             <Row>
                                <Col md={12}>
                                    <div className="form-group">
                                        <label>{LBL_CLIENT_NAME}</label>
                                        <div className="input-input disabledElement"><input  type="text" disabled  name="position" value={clientName || ''}  tabIndex="7" /></div>
                                    </div>
                                </Col>                        
                            </Row>}
                            <Row>
                                <Col md={6}>
                                    <div className="form-group">
                                        <label>{LBL_FIRST_NAME}</label>
                                        <div className="text-input"><input type="text" name="firstName" onChange={this.onHandleChange} className={formErrors.firstName.length >0 ? "input-error" : ''} value={contactData.firstName || ''} tabIndex="1" /></div>
                                    </div>
                                </Col>
                                <Col md={6}>
                                    <div className="form-group">
                                        <label>{LBL_LAST_NAME}</label>
                                        <div className="text-input"><input type="text" className={formErrors.lastName.length >0 ? "input-error" : ''} onChange={this.onHandleChange} name="lastName" value={contactData.lastName || ''}  tabIndex="2" /></div>
                                    </div>
                                </Col>
                            </Row>
                            <Row>
                                <Col md={id==="quotes-contact-add"?12:6}>
                                    <div className="form-group">
                                        <label>{LBL_CONTACT_NUMBER}</label>
                                        <div className={formErrors.contactNumber.length>0?'input-error':''}>
                                            <PhoneInput 
                                              country={PHONE_ISD_CODE}
                                              inputProps={{
                                                name: 'contactNumber',
                                                tabIndex: "3"
                                              }}
                                              value={contactData.contactNumber || PHONE_ISD_NUM}
                                              onChange={this.onPhoneInputChange} 
                                            />
                                        </div>
                                    </div>
                                </Col>
                                <Col md={id==="quotes-contact-add"?12:6}>
                                    <div className="form-group">
                                        <label>{LBL_EMAIL_ADDRESS}</label>
                                        <div className="input email-input"><input type="email" className={formErrors.emailAddress.length >0 ? "input-error" : ''} onChange={this.onHandleChange} name="emailAddress" value={contactData.emailAddress || ''}  tabIndex="4" />
                                        {formErrors.emailAddress.length >0 && formErrors.emailAddress!==MSG_REQUIRED && (
                                            <div className="text-red left-align text-12">{formErrors.emailAddress}</div>
                                        )} 
                                        <small className="text-red">{contactId > 0 && contactData.emailVerify===false && contactData.emailAddress?LBL_NOT_VERIFIED:''}</small>
                                        {contactId > 0 && <Link className={contactData.emailVerify===false&&contactData.emailAddress?'resend-btn float-right':'hide'} to="#" onClick={e => this.props.resendEmailAction(contactId)}  >{LBL_RESEND_VERIFI_EMAIL}</Link>} 
                                        </div>
                                    </div>
                                </Col>
                            </Row>
                            <Row>
                                <Col md={id==="quotes-contact-add"?12:6}>
                                    <div className="form-group">
                                        <label>{LBL_ROLE}</label>
                                        <div className="select-input disabledElement">
                                        <select name="role" onChange={this.onHandleChange} value={contactData.role || 0} className={''} disabled tabIndex="6">
                                            {/*roles && roles.length > 1 &&  <option value="0">Select Role</option> */}
                                            {roles.map((item) => <option key={item.id} value={item.id}>{item.name}</option>)}  
                                        </select>
                                        </div>
                                    </div>
                                </Col>
                                <Col md={id==="quotes-contact-add"?12:6}>
                                    <div className="form-group">
                                        <label>{LBL_POSITION}</label>
                                        <div className="input-input"><input  type="text" onChange={this.onHandleChange} name="position" value={contactData.position || ''}  tabIndex="7" /></div>
                                    </div>
                                </Col>                        
                            </Row>
                            {id!=="quotes-contact-add" && <Row>
                               <Col md={6}>
                                  <div className="custom-checkbox"><input type="checkbox" id="muteMailsC" name="muteMails" onChange={this.onHandleChange} checked={contactData.muteMails}/><label className="checkbox" htmlFor="muteMailsC"></label><label className="labeltext" htmlFor="muteMailsC">{LBL_MUTE_EMAILS}</label></div>
                               </Col>
                               <Col md={6}>
                                  <div className="custom-checkbox"><input type="checkbox" id="mutePushsC" name="mutePushs" onChange={this.onHandleChange} checked={contactData.mutePushs}/><label className="checkbox" htmlFor="mutePushsC"></label><label className="labeltext" htmlFor="mutePushsC">{LBL_MUTE_NOTICATIONS}</label></div>
                               </Col>
                            </Row>}
            
                            {(contactId==='' && id!=="quotes-contact-add" )&& <Row>
                                <Col md={6} >
                                    <div className="checkbox-wrapper conct-detailss form-group">
                                        <label></label>
                                        <div className="custom-checkbox">
                                            <input onChange={this.onHandleChange} name="sendEmail" 
                                            checked={contactData.sendEmail||false} type="checkbox" id="sendEmail" disabled={contactData.emailVerify}  tabIndex="8" /><label className="checkbox" htmlFor="sendEmail"  tabIndex="8"  ></label><label className="labeltext" htmlFor="sendEmail">{LBL_SEND_VERIFI_EMAIL}</label>
                                        </div>
                                    </div> 
                                </Col>
                            </Row>}
                        </Form.Group>
                    </Form>
                </div>


                <ModalWindow ref={this.modalCropper} type="imageCropper" saveFormData={ (e)=>this.cropImage(e)}>
                <Cropper
                    image={logoUrl}
                    crop={this.state.crop}
                    zoom={this.state.zoom}
                    aspect={this.state.aspect}
                    onCropChange={this.onCropChange}
                    onCropComplete={this.onCropComplete}
                    onZoomChange={this.onZoomChange}
                  />
                </ModalWindow>

            </div>        
        )
    }

}

const mapStateToProps = (state) => {
    return {
        contactList:state.clients.contactList,
        count:state.clients.count,
        contactUser:state.clients.contactUser,
        status:state.clients.status,
        activity:state.clients.activity,
        contactActivity:state.clients.contactActivity,   
        contactUserData:state.clients.contactUserData,
        subactivity: state.clients.contactActivity,  
        roles:state.clients.roles,
        errorData:state.clients.errorData,
        sendMailStatus:state.clients.sendMailStatus,
    }
}

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({
        clientContactAddAction:clientContactAddAction,
        assUserEditAction:id=>assUserEditAction(id),
        assUserUpdateAction:data=>assUserUpdateAction(data),
        profileRoleGetAction:profileRoleGetAction,
        resendEmailAction:resendEmailAction,
        clearAction:clearAction   
    },dispatch);
}
export default connect(mapStateToProps,mapDispatchToProps)(ClientContactAdd);